import { Component, inject, input } from '@angular/core'
import { NCBannerComponent } from '../components/banner/nc-banner.component.js'
import { CartComponentModule } from '../components/cart/cart.component.module.js'
import { SignalStore } from '../core/store/signalStore.js'
import { SharedModule } from '../shared/shared.module.js'

@Component({
  selector: 'app-discount-banner',
  imports: [NCBannerComponent, SharedModule, CartComponentModule],
  templateUrl: './discount-banner.component.html',
  styleUrl: './discount-banner.component.scss',
})
export class DiscountBannerComponent {
  protected store = inject(SignalStore)
  protected discountCode = this.store.$discountCode

  public centered = input(false)
  public bottomMargin = input(false)
  public topMargin = input(false)
  public isTest366 = input(false)
}
